import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CoachingLibraryCatalogue } from '@euler/model/coaching';
import { memo } from 'react';
import { Pressable } from 'react-native';
import { CollectionIllustration } from './CollectionIllustration';

type Collection = CoachingLibraryCatalogue['collections'][number];

/** A collection in the 全部合集 grid: its illustration, name and size. */
export const CollectionCard = memo(
  ({
    collection,
    onPress,
  }: {
    collection: Collection;
    onPress: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <Pressable
        onPress={onPress}
        accessibilityRole="button"
        style={({ pressed }) => ({
          flex: 1,
          alignItems: 'center',
          borderRadius: rpx(14),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.card,
          paddingHorizontal: rpx(12),
          paddingVertical: rpx(16),
          opacity: pressed ? 0.85 : 1,
        })}
      >
        <CollectionIllustration slug={collection.slug} size={rpx(84)} />
        <Typography.Text
          size={rpx(14)}
          bold
          color={aiColors.foreground}
          numberOfLines={1}
          style={{ marginTop: rpx(12), textAlign: 'center' }}
        >
          {collection.name}
        </Typography.Text>
        <Typography.Text
          size={rpx(12)}
          color={aiColors.mutedForeground}
          style={{ marginTop: rpx(2) }}
        >
          {collection.caseCount} 个场景
        </Typography.Text>
      </Pressable>
    );
  },
);
